export const CALENDAR_GRID_WEEK_FIRST_DAY_INDEX = 0

export const CALENDAR_GRID_WEEK_GRID_LINE_OFFSET = 1

export const CALENDAR_GRID_WEEK_SPAN_END_LINE_OFFSET = 2
